import { HttpErrorResponse } from '@angular/common/http';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { ActiveRepo } from '@commoncore/services/universal.service';
import { LocalStorageSvc } from '../services/localStorage.service';
import { JustifiedView } from '../utils/JustifiedViewUtil';


export class HomePageImplementation {
    public router: any;
    public http: any;
    public route:any;
    public universalService:any;
    private _route:any;
    public JSview:JustifiedView;
    localStorageSvc: LocalStorageSvc
    static singleInstance:any = null;
    constructor(globalService) {
        this.setHandler(globalService)
    }
    

    public setHandler(globalService){
      this.universalService=globalService.getUniversalServiceRef();
      this.route = globalService.getActivatedRoute();
      this.http = globalService.getHttpClientRef();
      this.router = globalService.getRouterRef();
      this.JSview = new JustifiedView(this.universalService);
      this.localStorageSvc = globalService.getLocalStorageSvcRef()
    }

    public static getInstance(globalService):HomePageImplementation{
      if(this.singleInstance == null){
        this.singleInstance = new HomePageImplementation(globalService);
        return this.singleInstance;
      }else{
        return this.singleInstance;
      }
    }

    fetchingShareKeyFromUrl(route) {
        
        if(route.queryParams){
           if (route.queryParams['t']) {
            this.universalService.shareKey = route.queryParams['t'];
            this.universalService.shardKey = route.queryParams['s'];
            var shareKey = this.localStorageSvc.getLocalProperty("shareKey",true);
            if(shareKey!=null  && shareKey!=this.universalService.shareKey){
                this.localStorageSvc.removeLocalProperty(LocalStorageProps.CURRENT_TAB);
            }
            if (this.universalService.shardKey == undefined) {
                this.universalService.sharingAlbumFiles = true
                this.localStorageSvc.setLocalProperty(LocalStorageProps.SHARE_KEY, this.universalService.shareKey,true);
            } else {
                this.localStorageSvc.setLocalProperty(LocalStorageProps.SHARE_KEY, this.universalService.shareKey,true);
                this.localStorageSvc.setLocalProperty(LocalStorageProps.SHARD_KEY, this.universalService.shardKey,true);
                this.universalService.sharingAlbumFiles = false
            }
            return true;
            }
        }   
        else {

            this.localStorageSvc.setImageExists(false, true);
            this.localStorageSvc.setAudiosExists(false, true);
            this.localStorageSvc.setVideosExists(false, true);
            this.localStorageSvc.setOthersExists(false, true);
            this.universalService.isServerError = true;
            setTimeout(function() {
                jQuery(".internal-server-error p").text("Share link is invalid");
            }, 10);
            return false;
        }
        
    }

    
    

    fetchSummary(summaryUrl,fetchFolderData){
        var classRef = this;
        return new Promise(function(resolve,reject){
            classRef.http.get(summaryUrl).subscribe(
                suc=>{
                    classRef.setSummaryDetails(suc,fetchFolderData)
                    classRef.universalService.summaryData = suc;
                    classRef.universalService.isServerError = false;
                    resolve(true);
                },
                (error:HttpErrorResponse) =>{
                    classRef.universalService.showLoader = false;
                    classRef.localStorageSvc.setImageExists(false, true);
                    classRef.localStorageSvc.setAudiosExists(false, true);
                    classRef.localStorageSvc.setVideosExists(false, true);
                    classRef.localStorageSvc.setOthersExists(false, true)
                    if(error.status == 500 || error.status == 502 || error.status == 503 ||error.status == 504){
                      console.log("inside summery catch if",error.status)
                      classRef.universalService.isServerError = true;
                    }else{
                      classRef.universalService.isServerError = false;
                    }
                    console.log("summery error",error)
                    reject(error);
                }
            )
        })
    }

    shareFetchSummary(summaryUrl,fetchFolderData){
      var classRef = this;
      var params = {
      }
      return new Promise(function(resolve,reject){
          classRef.http.get(summaryUrl,params).subscribe(
              suc=>{
                  classRef.setSummaryDetails(suc,fetchFolderData)
                  classRef.universalService.summaryData = suc;
                  classRef.universalService.isServerError = false;
                  resolve(true);
              },
              (error:HttpErrorResponse) =>{
                  classRef.universalService.showLoader = false;
                  classRef.localStorageSvc.setImageExists(false, true);
                  classRef.localStorageSvc.setAudiosExists(false, true);
                  classRef.localStorageSvc.setVideosExists(false, true);
                  classRef.localStorageSvc.setOthersExists(false, true)
                  if(error.status == 500 || error.status == 502 || error.status == 503 ||error.status == 504){
                    console.log("inside summery catch if",error.status)
                    classRef.universalService.isServerError = true;
                  }else{
                    classRef.universalService.isServerError = false;
                  }
                  console.log("summery error",error)
                  reject(false);
              }
          )
      })
  }

  

    setSummaryDetails(suc,fetchFolderData) {
      let classRef = this;
      if(this.universalService.activeRepo == "share"){
        suc = suc["summary"];
      }
      if(jQuery.isEmptyObject(suc) && this.universalService.selectedNodes == 0){
          this.universalService.showLoader = false;
      } else if(!fetchFolderData){
    
        const imagesExists = suc["image"]? true : false;
        this.universalService.sharedImages = imagesExists ? suc["image"] : [];
        classRef.localStorageSvc.setImageExists(imagesExists, true);
      
        const audiosExists = suc["audio"] ? true : false;
        this.universalService.sharedAudios = audiosExists ? suc["audio"]: [];
        classRef.localStorageSvc.setAudiosExists(audiosExists, true);
        
        const videosExists = suc["video"] ? true : false;
        this.universalService.sharedVideos = videosExists ? suc["video"]: [];
        classRef.localStorageSvc.setVideosExists(videosExists, true);

        const othersExists = suc["others"] ? true : false;
        this.universalService.sharedDocs = othersExists ? suc["others"]: [];
        classRef.localStorageSvc.setOthersExists(othersExists, true);

        this.universalService.sharedRoot  = suc["all"]?  suc["all"]:[]
        if(classRef.universalService.activeRepo == ActiveRepo.SHARE){
          classRef.localStorageSvc.setShareImageExists(imagesExists, true);
          classRef.localStorageSvc.setShareAudiosExists(audiosExists, true);
          classRef.localStorageSvc.setShareVideosExists(videosExists, true);
          classRef.localStorageSvc.setShareOthersExists(othersExists, true)
        }
        
        if (suc["folders"]) {
          this.universalService.totalCountOfFolders = suc["folders"][0]["fileCount"]
        }

        if (this.universalService.sharedImages.length != 0 && this.universalService.sharedAudios.length == 0 && this.universalService.sharedDocs.length == 0 && this.universalService.sharedVideos.length == 0) {
          this.universalService.showJustifiedLayout = true;
        } else {
          this.universalService.showJustifiedLayout = false;
        }
        
      } else if (JSON.stringify(suc).length > 0 && fetchFolderData) {
        fetchFolderData = false;
        this.universalService.sharedRoot = suc["all"];
        //this.universalService.sharedRoot = suc["all"]? suc["all"]: suc["summary"];
        if (suc["folders"]) {
          this.universalService.totalCountOfFolders = suc["folders"][0]["fileCount"]
        }

        var images, audios, videos, others = [];
        if (suc["image"]) {
          images = suc["image"]
        } else {
          images = []
        }
        if (suc["audio"]) {
          audios = suc["audio"]
        } else {
          audios = []
        }
        if (suc["video"]) {
          videos = suc["video"]
        } else {
          videos = []
        }
        if (suc["others"]) {
          others = suc["others"]
        } else {
          others = []
        }

        if (images.length != 0 && audios.length == 0 && others.length == 0 && videos.length ==0) {
          this.universalService.showJustifiedLayout = true;
        } else {
          this.universalService.showJustifiedLayout = false;
        }
      }
      this.setGlobalCountForfilters()
   
    }
    

    setGlobalCountForfilters(){
      var obj = this.universalService.sharedAudios;
      this.universalService.priviewAudioFileCount = 0;
        obj.forEach(obj => {
          this.universalService.priviewAudioFileCount = this.universalService.priviewAudioFileCount + parseInt(obj.fileCount)
        });
    }
}
